import React, { useState, useEffect, useCallback } from 'react';
import Login from './pages/Login';
import Layout from './components/Layout';
import { refreshAccessToken, logoutApi } from './api/authApi';
import { fetchGroupList, fetchCodeList } from './api/codeApi';
import JoinPage from './pages/JoinPage';
import MentimeterResponsePage from './pages/MentimeterResponsePage';
import SurveyResponsePage from './pages/SurveyResponsePage';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));
  const [userLevel, setUserLevel]   = useState(localStorage.getItem('userLevel') || '2');
  
  const params       = new URLSearchParams(window.location.search);
  const isJoinPage   = params.get('page') === 'join';
  const isMentiPage  = params.get('page') === 'mentimeter';
  const branchCode   = params.get('branch');
  const divisionCode = params.get('division');
  const mentiYear    = params.get('year');
  const seqNo        = params.get('seq');

  const isSurveyPage = params.get('page') === 'survey';
  const surveyYear    = params.get('year');
  const surveySeqNo   = params.get('seq');

  // ✅ Hook 먼저 전부 선언
  const handleLogout = useCallback(async (isForced = false) => {
    if (!isForced) await logoutApi();  // 강제 로그아웃 시엔 이미 토큰이 무효하므로 logout API 호출 스킵
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    localStorage.removeItem('userLevel');
    // ↓ branch_code, division_code는 의도적으로 보존 (Login.jsx에서 자동 복원용)
    Object.keys(localStorage)
      .filter(k => k.startsWith('code_'))
      .forEach(k => localStorage.removeItem(k));
    setIsLoggedIn(false);
  }, []);

  // 세션 만료 이벤트 수신 → 강제 로그아웃
  useEffect(() => {
    const onSessionExpired = () => handleLogout(true);
    window.addEventListener('session-expired', onSessionExpired);
    return () => window.removeEventListener('session-expired', onSessionExpired);
  }, [handleLogout]);

  const loadCommonCodes = async () => {
    try {
      const groupRes = await fetchGroupList();
      if (!groupRes.success) return;
      for (const group of groupRes.data) {
        const codeRes = await fetchCodeList(group.group_cd);
        if (codeRes.success) {
          localStorage.setItem(`code_${group.group_cd}`, JSON.stringify(codeRes.data));
        }
      }
    } catch (err) {
      console.error('공통코드 로드 실패:', err);
    }
  };

  const handleLoginSuccess = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    setUserLevel(user.user_level);
    await loadCommonCodes();
    setIsLoggedIn(true);
  };

  useEffect(() => {
    if (!isLoggedIn) return;
    const interval = setInterval(async () => {
      const newToken = await refreshAccessToken();
      if (!newToken) handleLogout();
    }, 110 * 60 * 1000);
    return () => clearInterval(interval);
  }, [isLoggedIn, handleLogout]);

  // ✅ 그 다음에 조건 return
  if (isJoinPage) {
    return <JoinPage branchCode={branchCode} divisionCode={divisionCode} />;
  }

  // 멘티미터 응답 페이지 (로그인 불필요)
  if (isMentiPage) {
    return (
      <MentimeterResponsePage
        branchCode={branchCode}
        divisionCode={divisionCode}
        mentiYear={mentiYear}
        seqNo={seqNo}
      />
    );
  }

  if (isSurveyPage) {
    return (
      <SurveyResponsePage
        branchCode={branchCode}
        divisionCode={divisionCode}
        surveyYear={surveyYear}
        seqNo={surveySeqNo}
      />
    );
  }

  return (
    <div>
      {isLoggedIn
        ? <Layout onLogout={handleLogout} userLevel={userLevel} />
        : <Login onLoginSuccess={handleLoginSuccess} />
      }
    </div>
  );
}

export default App;